<div class="text-center">
    <img src="/assets/images/empty-list.png" [ngClass]="{'small-img': smallImg === true}">
    <h1>{{title}}</h1>
    <h2>{{subTitle}}</h2> 
</div>